export const translatableKey = string => {
    if (!string) {
        return '';
    }
    return string
        .trim()
        .split(' ')
        .join('_')
        .toLowerCase();
};
